import {Component, Injector, OnInit, ViewChild} from '@angular/core';
import {Company} from "../../models/company";
import {CompanyService, PosNexiTerminal} from "../../services/company/company.service";
import Swal, {SweetAlertResult} from "sweetalert2";
import {TableComponent} from "../ui/table/table.component";
import {User} from "../../models/user";
import {UserGroup} from "../../models/userGroup";
import {BaseComponent} from "../base/base.component";
import {NgxSmartModalService} from "ngx-smart-modal";
import {UserService} from "../../services/user/user.service";
import {CompanyDocument} from "../../models/CompanyDocument";
import {CompanyDocumentService} from "../../services/companyDocument/document.service";
import {AdminDocument} from "../../models/adminDocument";
import {AdminDocumentService} from "../../services/adminDocument/admin-document.service";
import {Permissions} from "../../resources/permissions";
import {ActivatedRoute, Router} from "@angular/router";
import {AgentService} from "../../services/agent/agent.service";
import {PaymentService} from "../../services/payment/payment.service";
import {StripeInvoice} from "../../models/stripe-invoice";
import {environment} from "../../environments/environment";
import {Constants} from "../../constants";
import {HttpClient, HttpHeaders} from "@angular/common/http";
import {Category} from "../../models/category";
import {CategoryService} from "../../services/category/category.service";
import {SeasonService} from "../../services/season/season.service";
import {CompanyLegalDocumentField} from "./general/legal/companies-settings-legal.component";

@Component({
    selector: 'app-companies-settings',
    templateUrl: './companies-settings.component.html',
    styleUrls: ['./companies-settings.component.scss']
})
export class CompaniesSettingsComponent extends BaseComponent implements OnInit {

    @ViewChild('athleteDocumentsTable') athleteDocumentsTable: TableComponent | undefined;
    @ViewChild('adminDocumentsTable') adminDocumentsTable: TableComponent | undefined;
    @ViewChild('confirmPassword') public confirmPassword: any;

    newPassword: string = '';
    resubmitPassword: string = '';
    showInvitePassword = false;
    showInviteConfirmPassword = false;

    canApproveRejectCompanyDocument: boolean = false;
    hasGlobalVisibility: boolean = false;
    canEditPaymentMethod: boolean = true;

    company: Company = new Company();
    newUser: User = new User();

    /** Ruoli caricati dall’API; usati nell’invite e come etichette in tabella. */
    companyInviteRoleOptions: UserGroup[] = [];
    /** Valore selezionato per la nuova persona (id gruppo dall’API). */
    selectedInviteRoleId = '';

    /** Opzioni categoria per invito mister (`name` = etichetta per welldone-multiselect). */
    inviteMisterCategoryOptions: { id: string; name: string }[] = [];
    /** Categorie selezionate (oggetti come negli altri multiselect del progetto). */
    inviteMisterCategoriesSelected: { id: string; name: string }[] = [];
    /** Categorie selezionate in modifica accesso (mister). */
    editMisterCategoriesSelected: { id: string; name: string }[] = [];
    /** Evita che il multiselect si inizializzi prima delle categorie già assegnate. */
    editMisterCategoriesReady = false;
    inviteMisterCategoriesLoading = false;

    tabNumber: number = 0; //diverso da 0 per comodità sviluppo
    companyId: string = '';
    pageLoading = true;

    athleteDocument: CompanyDocument = new CompanyDocument();
    adminDocuments: AdminDocument[] = [];
    adminDocumentType: string = '';
    adminDocumentFile: File | undefined;
    companyRulesFile: File | undefined;
    companySignatureFile: File | undefined;

    modelDocument: File | undefined;
    modelDocumentUrl: string = '';
    showModelDocumentPreview: boolean = false;

    data: any[] = [];
    cities: any[] = [];
    legalCities: any[] = [];
    provinces: any[] = [];
    companyRaw: Record<string, unknown> | null = null;
    savingCompany = false;
    approvingCompany = false;
    legalDocumentUploading: Partial<Record<CompanyLegalDocumentField, boolean>> = {};

    responseCompanyRules: string = '';
    responseCompanySignature: string = '';


    primaryDocumentExists: boolean = false;

    agents: User[] = [];

    companyHasShop: boolean = false;

    showUpdateStripePaymentContent = false;
    currentCardDetails: any = null;
    currentInvoice: StripeInvoice | null = null;

    documentTypes = [
        {id: 'italiano', name: 'Italiano'},
        {id: 'europeo_non_ita', name: 'Europeo non ITA'},
        {id: 'extra_comunitario_eu', name: 'Extra comunitario EU'},
        {id: 'mister', name: 'Mister'}
    ];
    selectedDocumentTypes: { id: string, name: string }[] = [];
    TypeDropdownSettings: any = {};
    editDocumentSelectedTypes: { id: string, name: string }[] = [];

    /** Utenti legati alla società (tab Team — senza ui-table). */
    linkedCompanyTeamUsers: User[] = [];
    linkedCompanyTeamLoading = false;

    activePaymentPanel: 'Nexi' | 'WireTransfer' | 'NexiRates' | 'AppPagoRates' | 'NexiPos' | null = null;
    get enabledPaymentMethodsCount(): number {
        return [
            this.company.nexiEnabled,
            this.company.wireTransferEnabled,
            this.company.nexiRatesEnabled,
            this.company.appPagoRatesEnabled,
            this.company.posNexiEnabled,
            this.company.localPaymentEnabled,
        ].filter(Boolean).length;
    }

    posNexiTerminals: PosNexiTerminal[] = [];
    posNexiTerminalsLoading = false;
    posNexiTerminalsError = '';
    showPosNexiMacKey = false;
    private posNexiTerminalBusinessId = '';
    private posNexiTerminalRequestId = 0;

    constructor(public route: ActivatedRoute,
                public router: Router,
                public companyService: CompanyService,
                public adminDocumentService: AdminDocumentService,
                public userService: UserService,
                public companyDocumentService: CompanyDocumentService,
                public modal: NgxSmartModalService,
                private agentService: AgentService,
                private paymentService: PaymentService,
                private http: HttpClient,
                private categoryService: CategoryService,
                private seasonService: SeasonService,
                public serviceInjector: Injector) {
        super(serviceInjector);
    }

    async ngOnInit() {
        this.companyId = this.route.snapshot.params['companyId'] ?? '';
        this.canApproveRejectCompanyDocument = this.hasPermission(Permissions.approveRejectCompanyDocument) ?? false;
        this.hasGlobalVisibility = this.hasPermission(Permissions.globalVisibility) ?? false;

        this.utils.hasShopService.subscribe(active => this.companyHasShop = active);

        this.TypeDropdownSettings = {
            idField: 'id',
            textField: 'name',
            allowSearchFilter: false
        };

        void this.bootstrapPage();
    }

    private async bootstrapPage(): Promise<void> {
        this.pageLoading = true;
        void this.loadLocations();
        void this.loadAgents();
        void this.loadStripeCardDetails();
        void this.loadCompanyInviteRoles();
        void this.loadAdminDocuments();
        void this.loadLinkedCompanyTeamUsers();

        try {
            await this.loadCompany();
        } catch (error) {
            console.error('error bootstrapPage loadCompany: ', error);
        } finally {
            this.pageLoading = false;
        }

        void this.maybeDisableNexiRates();
    }

    private async loadLocations(): Promise<void> {
        try {
            const jsonData = await fetch('../../../assets/italia_comuni.json');
            const res = await jsonData.json();
            this.data = res.regioni;
            this.provinces = [];
            this.data.forEach((region: any) => {
                region.province.forEach((province: any) => this.provinces.push({
                    id: province.code,
                    name: province.nome
                }));
            });
            this.provinces.sort((a: any, b: any) => a.name > b.name ? 1 : -1);
            this.updateCitiesLegal();
            this.updateLegalResidenceCities();
        } catch (error) {
            console.error('error fetching locationData: ', error);
        }
    }

    private async loadAdminDocuments(): Promise<void> {
        try {
            const adminDocumentsResponse = await this.adminDocumentService.getAdminDocuments(this.companyId, 'company');
            if (adminDocumentsResponse.success) {
                this.adminDocuments = [...adminDocumentsResponse.data];
            }
        } catch (error) {
            console.error('error loadAdminDocuments: ', error);
        }
    }

    private async maybeDisableNexiRates(): Promise<void> {
        if (!this.company.nexiRatesEnabled) {
            return;
        }
        if (this.disableNexiRates()) {
            return;
        }
        this.company.nexiRatesEnabled = 0;
        try {
            await this.companyService.enableDisablePaymentMethod(
                {nexiRatesEnabled: this.company.nexiRatesEnabled},
                this.companyId
            );
        } catch (error) {
            console.error('error maybeDisableNexiRates: ', error);
        }
    }

    async loadStripeCardDetails() {
        try {
            const response: any = await this.paymentService.getStripeCardDetails(this.companyId);
            const cardDetails = response?.data?.card_details ?? response?.card_details;
            if (response && (response.success !== false) && cardDetails?.card) {
                this.currentCardDetails = {card_details: cardDetails};
            } else {
                this.currentCardDetails = null;
            }
        } catch (e) {
            console.error('error loadStripeCardDetails: ', e);
            this.currentCardDetails = null;
        }
    }

    async loadInvoice() {
        try {
            const response = await this.paymentService.getInvoice(this.companyId);
            this.currentInvoice = response?.success && response?.data ? response.data : null;
        } catch (e) {
            console.error('error loadInvoice: ', e);
            this.currentInvoice = null;
        }
    }

    async loadCompany() {
        let response: any = await this.companyService.getCompanyById(this.companyId ?? '');
        this.company = new Company(response.data);
        this.companyRaw = response?.data ?? null;

        if (this.isSuperAdmin()) {
            const authed: any = await this.companyService.getCompanyByIdAuthenticated(this.companyId);
            const authedData = authed?.data;
            if (authedData && typeof authedData === 'object') {
                this.company = new Company({...(response.data || {}), ...authedData});
                this.companyRaw = {...(this.companyRaw || {}), ...authedData};
                const fromUsers = Array.isArray(authedData.users)
                    ? authedData.users
                        .map((user: {recoveryNumber?: string; otp?: string; otpCode?: string}) =>
                            user?.recoveryNumber || user?.otp || user?.otpCode)
                        .find((value: unknown) => String(value || '').trim())
                    : '';
                const otp = String(
                    authedData.otp || authedData.OTP || authedData.otpCode || fromUsers || ''
                ).trim();
                if (otp) {
                    this.company.otp = otp;
                }
            }
        }

        if (response.data.rulesUrl) {
            this.responseCompanyRules = response.data.rulesUrl
        }
        if (response.data.signature) {
            this.responseCompanySignature = response.data.signature
        }
        this.updateCitiesLegal();
        this.updateLegalResidenceCities();
    }

    async loadAgents() {
        let params: any = {};
        let response: any = await this.agentService.get(params);
        if (response.success) {
            this.agents = response.data;
        }
    }

    async setTabNumber(index: number) {
        this.tabNumber = index;

        if (index === 5 && (this.company.service?.id || this.company.stripeSubscriptionId)) {
            await this.loadInvoice();
        }

        if (index === 2 || index == 3 || index === 4) {
            // timeout serve perchè sennò i dati non vengono mostrati a schermo
            setTimeout(async () => {
                await this.primaryDocumentCheck()
            }, 100);
        }

    }

    private teamUsersApiHeaders(): HttpHeaders {
        return new HttpHeaders({
            'Content-Type': 'application/json',
            Accept: 'application/json',
            Authorization: localStorage.getItem(Constants.LOCAL_TOKEN) ?? environment.publicApiToken,
        });
    }

    /** Lista team: stesso endpoint della precedente ui-table (`GET /users`). */
    async loadLinkedCompanyTeamUsers() {
        if (!this.companyId?.length) {
            this.linkedCompanyTeamUsers = [];
            return;
        }
        this.linkedCompanyTeamLoading = true;
        try {
            const response: any = await this.http
                .get(environment.apiUrl + '/users', {
                    params: {
                        linkedCompanyId: this.companyId,
                        $skip: '0',
                        $top: '500',
                    },
                    headers: this.teamUsersApiHeaders(),
                })
                .toPromise();
            if (response?.success && Array.isArray(response.data)) {
                this.linkedCompanyTeamUsers = response.data.map((item: unknown) => new User(item as User));
                void this.enrichTeamUserDocuments();
            } else {
                this.linkedCompanyTeamUsers = [];
            }
        } catch (e) {
            console.error('loadLinkedCompanyTeamUsers', e);
            this.linkedCompanyTeamUsers = [];
        } finally {
            this.linkedCompanyTeamLoading = false;
        }
    }

    private isCompanyManagerUser(user: User): boolean {
        const role = (user.userGroupId ?? '').trim().toLowerCase();
        if (role === 'companymanager') {
            return true;
        }
        const email = (user.email ?? '').trim().toLowerCase();
        const legalEmail = (this.company.legalEmail ?? '').trim().toLowerCase();
        return !!email && !!legalEmail && email === legalEmail;
    }

    private async enrichTeamUserDocuments(): Promise<void> {
        const managers = this.linkedCompanyTeamUsers.filter((user) => this.isCompanyManagerUser(user) && !!user.id);
        if (managers.length === 0) {
            return;
        }
        const details = await Promise.all(managers.map(async (user) => {
            try {
                return await this.userService.getUserById(user.id!);
            } catch {
                return user;
            }
        }));
        const byId = new Map(details.filter((user) => !!user.id).map((user) => [user.id, user]));
        this.linkedCompanyTeamUsers = this.linkedCompanyTeamUsers.map((user) => {
            const full = user.id ? byId.get(user.id) : undefined;
            if (!full) {
                return user;
            }
            return new User({
                ...user,
                ...full,
                documentUrlFront: full.documentUrlFront || user.documentUrlFront,
                documentUrlBack: full.documentUrlBack || user.documentUrlBack,
                fiscalCodeFront: full.fiscalCodeFront || (full as User & {fiscalCodeUrlFront?: string}).fiscalCodeUrlFront || user.fiscalCodeFront,
                fiscalCodeBack: full.fiscalCodeBack || (full as User & {fiscalCodeUrlBack?: string}).fiscalCodeUrlBack || user.fiscalCodeBack,
                fiscalCodeDocumentUrl: full.fiscalCodeDocumentUrl || user.fiscalCodeDocumentUrl,
                fiscalCode: full.fiscalCode || user.fiscalCode,
                documentNumber: full.documentNumber || user.documentNumber,
                phone: full.phone || user.phone,
                lastAccess: full.lastAccess || user.lastAccess,
                status: full.status || user.status,
                otp: full.otp || (full as User).recoveryNumber || user.otp,
            });
        });
    }

    /** Iniziali per avatar circolare (tab Team). */
    teamMemberInitials = (user: User): string => {
        const fn = (user.firstName ?? '').trim();
        const ln = (user.lastName ?? '').trim();
        const initials = `${fn.slice(0, 1)}${ln.slice(0, 1)}`.replace(/\s/g, '').toUpperCase();
        if (initials.length >= 2) {
            return initials.slice(0, 2);
        }
        if (initials.length === 1) {
            return initials;
        }
        const mail = (user.email ?? '').trim();
        return mail.slice(0, 2).toUpperCase() || '?';
    }

    async loadData() {
        await this.loadLinkedCompanyTeamUsers();
        await this.athleteDocumentsTable?.loadData('/companyDocuments', {companyId: this.companyId}, (item: any) => new CompanyDocument(item));
        // await this.adminDocumentsTable?.loadData('/adminDocuments', {requestedTo: 'company'}, (item: any) => {new AdminDocument(item)});
        await this.adminDocumentsTable?.loadData('/companyAdminDocuments', {
            requestedTo: 'company',
            companyId: this.companyId
        }, (item: any) => new AdminDocument(item));
    }

    clearModalData(modalName: string) {
        this.modal.resetModalData(modalName)
    }

    // * Company
    async updateCompanyPicture(event: any) {

        const companyPicture = event.target.files[0];

        if (!companyPicture) return;

        const formData = new FormData();
        formData.append('file', companyPicture)

        this.spinner.show();

        // upload dell'immagine
        const {success, data} = await this.companyService.uploadCompany(formData);
        if (success) {
            this.company.logoUrl = data;
            try {
                // aggiorno la company direttamente, senza dover cliccare il salva
                if ((await this.companyService.updateCompany(this.company.id, this.company)).success) {
                    Swal.fire({
                        icon: 'success',
                        title: 'Immagine caricata con successo! ',
                    })
                } else {
                    Swal.fire({
                        icon: 'error',
                        title: "Errore nel caricamento dell'immagine! "
                    })
                }

            } catch (e) {
                console.error('error: ', e)
            }
        } else {
            Swal.fire({
                icon: 'error',
                title: 'Errore nel caricamento immagine ',
            })
        }

        this.spinner.hide();
    }

    async updateCompany() {
        this.savingCompany = true;
        try {
            if ((await this.companyService.updateCompany(this.company.id, this.company)).success) {
                Swal.fire({
                    icon: 'success',
                    title: 'Società aggiornata correttamente',
                })
            } else {
                Swal.fire({
                    icon: 'error',
                    title: "Errore nell'aggiornamento della società",
                })
            }
        } finally {
            this.savingCompany = false;
        }
    }

    copyToClipboard(value: string) {
        if (!value) {
            return;
        }
        void navigator.clipboard.writeText(value);
    }

    async uploadLegalDocument(field: CompanyLegalDocumentField, event: Event) {
        const input = event.target as HTMLInputElement | null;
        const file = input?.files?.[0];
        if (!file) {
            return;
        }

        const formData = new FormData();
        formData.append('file', file);
        this.legalDocumentUploading = {...this.legalDocumentUploading, [field]: true};
        this.showSpinner();

        try {
            const upload = await this.companyService.uploadCompany(formData);
            if (!upload?.success) {
                Swal.fire({icon: 'error', title: 'Errore nel caricamento del documento'});
                return;
            }
            this.company[field] = upload.data;
            const updateResponse = await this.companyService.updateCompany(this.company.id, {[field]: upload.data});
            if (updateResponse?.success) {
                Swal.fire({icon: 'success', title: 'Documento caricato con successo'});
            } else {
                Swal.fire({icon: 'error', title: 'Errore nel salvataggio del documento'});
            }
        } catch (e) {
            console.error('uploadLegalDocument', e);
            Swal.fire({icon: 'error', title: 'Errore nel caricamento del documento'});
        } finally {
            this.legalDocumentUploading = {...this.legalDocumentUploading, [field]: false};
            this.hideSpinner();
            if (input) {
                input.value = '';
            }
        }
    }


    // * Payment
    paymentMethodTitle(type: string): string {
        switch (type) {
            case 'Nexi': return 'Carta di credito e bancomat';
            case 'wireTransfer': return 'Bonifico bancario';
            case 'NexiRates': return 'Rate mensili PagoDIL';
            case 'AppPagoRates': return 'Rate AppPago';
            case 'NexiPos': return 'POS Nexi';
            default: return 'Metodo di pagamento';
        }
    }

    savePaymentModal() {
        const data = this.ngxSmartModalService.getModal('editPaymentModal').getData();
        if (!data) return;
        if (data.posNexi) {
            void this.updatePaymentMethod('', '', '', data.type);
        } else if (data.wireTransfer) {
            void this.updatePaymentMethod(data.iban, data.beneficiary, data.commissionPercent, data.type);
        } else {
            void this.updatePaymentMethod(data.shopId, data.apiKey, data.commissionPercent, data.type);
        }
    }

    editPaymentMethod(event: MouseEvent, paymentType: string) {
        event.stopPropagation();
        event.preventDefault();

        let paymentData = {};

        if (paymentType === 'Nexi') paymentData = {
            wireTransfer: false,
            type: 'Nexi',
            shopId: this.company.nexiShopId,
            apiKey: this.company.nexiApiKey
        };
        /*if (paymentType === 'Soisy') paymentData = {
            wireTransfer: false,
            type: 'Soisy',
            shopId: this.company.soisyShopId,
            apiKey: this.company.soisyApiKey
        };*/
        if (paymentType === 'WireTransfer') paymentData = {
            wireTransfer: true,
            appPagoRates: false,
            type: 'wireTransfer',
            iban: this.company.wireTransferIban,
            beneficiary: this.company.wireTransferBeneficiary
        };
        if (paymentType === 'NexiRates') paymentData = {
            wireTransfer: false,
            nexiRates: true,
            appPagoRates: false,
            type: 'NexiRates',
            shopId: this.company.nexiRatesShopId,
            apiKey: this.company.nexiRatesApiKey,
            commissionPercent: this.company.nexiRatesCommissionPercent
        };
        if (paymentType === 'AppPagoRates') {
            paymentData = {
                wireTransfer: false,
                nexiRates: false,
                appPagoRates: true,
                type: 'AppPagoRates',
                shopId: this.company.appPagoShopId,
                apiKey: this.company.appPagoApiKey,
                apiSecret: this.company.appPagoApiSecret,
                commissionPercent: this.company.appPagoCommissionPercent
            };
            console.log('edit appPagoRates', paymentData)
        }

        if (paymentType === 'NexiPos') paymentData = {
            wireTransfer: false,
            posNexi: true,
            type: 'NexiPos',
            posNexiBusinessId: this.company.posNexiBusinessId || '',
            posNexiDeviceId: this.company.posNexiDeviceId || '',
            posNexiShopId: this.company.posNexiShopId || '',
            posNexiApiKey: this.company.posNexiApiKey || '',
        };


        this.ngxSmartModalService.setModalData(paymentData, 'editPaymentModal');
        this.ngxSmartModalService.getModal('editPaymentModal').open();
        if (paymentType === 'NexiPos') {
            this.showPosNexiMacKey = false;
            void this.loadPosNexiTerminals(this.company.posNexiBusinessId || '');
        }
    }

    async loadPosNexiTerminals(businessId: string) {
        const id = businessId.trim();
        const requestId = ++this.posNexiTerminalRequestId;
        this.posNexiTerminals = [];
        this.posNexiTerminalBusinessId = '';
        this.posNexiTerminalsLoading = false;
        if (!id) {
            this.posNexiTerminalsError = 'Inserisci l’Id azienda per vedere i terminali.';
            return;
        }
        this.posNexiTerminalsLoading = true;
        this.posNexiTerminalsError = '';
        const response = await this.companyService.getPosNexiTerminals(this.companyId, id);
        if (requestId !== this.posNexiTerminalRequestId) return;
        this.posNexiTerminalsLoading = false;
        if (!response.success) {
            this.posNexiTerminalsError = 'Impossibile caricare i terminali. Controlla l’Id azienda e riprova.';
            return;
        }
        this.posNexiTerminalBusinessId = id;
        this.posNexiTerminals = response.data;
        if (!response.data.length) {
            this.posNexiTerminalsError = 'Nessun terminale trovato per questo Id azienda.';
            return;
        }
        const modalData = this.ngxSmartModalService.getModal('editPaymentModal').getData();
        if (modalData?.posNexi && !response.data.some(item => item.deviceId === modalData.posNexiDeviceId)) {
            modalData.posNexiDeviceId = '';
        }
        if (modalData?.posNexi && response.data.length === 1 && !modalData.posNexiDeviceId) {
            modalData.posNexiDeviceId = response.data[0].deviceId;
        }
    }

    onPosNexiBusinessIdBlur(businessId: string) {
        const id = String(businessId || '').trim();
        if (id !== this.posNexiTerminalBusinessId) {
            void this.loadPosNexiTerminals(id);
        }
    }

    posNexiTerminalLabel(terminal: PosNexiTerminal) {
        const name = terminal.name || terminal.storeName || 'Terminale';
        const id = terminal.externalTerminalId || terminal.serialNumber || terminal.deviceId;
        return `${name} · ${id}`;
    }

    selectedPosNexiTerminalLabel() {
        if (!this.company.posNexiDeviceId) return 'Nessun terminale selezionato';
        const terminal = this.posNexiTerminals.find(item => item.deviceId === this.company.posNexiDeviceId);
        return terminal ? this.posNexiTerminalLabel(terminal) : this.company.posNexiDeviceId;
    }

    togglePaymentPanel(panel: 'Nexi' | 'WireTransfer' | 'NexiRates' | 'AppPagoRates' | 'NexiPos') {
        this.activePaymentPanel = this.activePaymentPanel === panel ? null : panel;
        if (this.activePaymentPanel === 'NexiPos' && this.company.posNexiBusinessId && this.posNexiTerminalBusinessId !== this.company.posNexiBusinessId) {
            void this.loadPosNexiTerminals(this.company.posNexiBusinessId);
        }
    }

    async updatePaymentMethod(first: string, second: string, commissionPercent: string, paymentMethodType: string) {

        let updatedCompany = {};
        if (paymentMethodType === 'Nexi') {
            updatedCompany = {nexiShopId: first, nexiApiKey: second}
        }
        /*else if (paymentMethodType === 'Soisy') {
            updatedCompany = {soisyShopId: first, soisyApiKey: second}
            console.log('edit soisy', updatedCompany)
        } */
        else if (paymentMethodType === 'wireTransfer') {
            updatedCompany = {wireTransferIban: first, wireTransferBeneficiary: second}
        } else if (paymentMethodType === 'NexiRates') {
            let correctCommissionPercent = commissionPercent.replace(',', '.')
            updatedCompany = {
                nexiRatesShopId: first,
                nexiRatesApiKey: second,
                nexiRatesCommissionPercent: correctCommissionPercent
            }
        } else if (paymentMethodType === 'AppPagoRates') {
            updatedCompany = {
                appPagoShopId: first,
                appPagoApiKey: second,
                appPagoCommissionPercent: commissionPercent,
                appPagoApiSecret: this.ngxSmartModalService.getModal('editPaymentModal').getData().apiSecret
            }
        } else if (paymentMethodType === 'NexiPos') {
            const modalData = this.ngxSmartModalService.getModal('editPaymentModal').getData();
            const businessId = String(modalData.posNexiBusinessId || '').trim();
            const deviceId = String(modalData.posNexiDeviceId || '').trim();
            if (!businessId) {
                await Swal.fire({icon: 'info', title: 'Inserisci l’Id azienda'});
                return;
            }
            if (this.posNexiTerminalsLoading) return;
            const currentSelectionUnchanged = businessId === this.company.posNexiBusinessId && deviceId === this.company.posNexiDeviceId;
            if (this.posNexiTerminalBusinessId !== businessId && !currentSelectionUnchanged) {
                await Swal.fire({icon: 'info', title: 'Aggiorna l’elenco dei terminali', text: 'Carica i terminali dell’Id azienda indicato prima di salvare.'});
                return;
            }
            if (!deviceId || (this.posNexiTerminalBusinessId === businessId && !this.posNexiTerminals.some(item => item.deviceId === deviceId))) {
                await Swal.fire({icon: 'info', title: 'Seleziona un terminale', text: 'Scegli il POS da usare per i pagamenti.'});
                return;
            }
            updatedCompany = {
                posNexiBusinessId: businessId,
                posNexiDeviceId: deviceId,
                posNexiShopId: String(modalData.posNexiShopId || '').trim(),
                posNexiApiKey: String(modalData.posNexiApiKey || '').trim(),
            }
        }
        
        else {
            updatedCompany = {};
        }

        if (!Object.keys(updatedCompany).length) {
            Swal.fire({icon: 'error', title: 'Errore durante la fase di aggiornamento'})
            return;
        }

        if (paymentMethodType !== 'NexiPos') this.ngxSmartModalService.getModal('editPaymentModal').close();
        this.spinner.show();

        if ((await this.companyService.updateCompany(this.company.id, updatedCompany))?.success) {
            await this.loadData();
            this.spinner.hide();
            await this.loadCompany();
            if (paymentMethodType === 'NexiPos') this.ngxSmartModalService.getModal('editPaymentModal').close();
            Swal.fire({
                icon: 'success',
                title: 'Metodo di pagamento aggiornato! ',
            })
        } else {
            this.spinner.hide();
            Swal.fire({
                icon: 'error',
                title: "Errore durante l'aggiornamento! ",
            })
        }

    }

    clearPaymentModal() {
        this.ngxSmartModalService.resetModalData('editPaymentModal');
    }

    openUpdateStripePaymentModal() {
        this.modal.getModal('updateStripePaymentModal').open();
    }

    onStripePaymentMethodUpdated() {
        this.modal.getModal('updateStripePaymentModal').close();
        this.loadCompany();
        this.loadStripeCardDetails();
        Swal.fire({
            icon: 'success',
            title: 'Metodo di pagamento aggiornato',
        });
    }

    async onSubscriptionReloaded() {
        await this.loadCompany();
        await this.loadStripeCardDetails();
        await this.loadInvoice();
    }

    deletePaymentMethod(event: any) {
        event.stopPropagation()
        event.preventDefault();
    }

    async enableDisableNexi() {
        this.company.nexiEnabled = this.company.nexiEnabled ? 0 : 1;
        await this.companyService.enableDisablePaymentMethod({nexiEnabled: this.company.nexiEnabled}, this.companyId);
    }

    async enableDisableAppPagoRates() {
        this.company.appPagoRatesEnabled = this.company.appPagoRatesEnabled ? 0 : 1;
        await this.companyService.enableDisablePaymentMethod({appPagoRatesEnabled: this.company.appPagoRatesEnabled}, this.companyId);
    }

    /*async enableDisableSoisy() {
        this.company.soisyEnabled = this.company.soisyEnabled ? 0 : 1;
        await this.companyService.enableDisablePaymentMethod({soisyEnabled: this.company.soisyEnabled}, this.companyId);
    }*/

    async enableDisableWireTransferEnabled() {
        this.company.wireTransferEnabled = this.company.wireTransferEnabled ? 0 : 1;
        await this.companyService.enableDisablePaymentMethod({wireTransferEnabled: this.company.wireTransferEnabled}, this.companyId);
    }

    async enableDisableNexiRates() {
        if (!this.disableNexiRates()) {
            Swal.fire({
                icon: 'error',
                title: "Per abilitare il metodo di pagamento a rate è necessario inserire tutti i dati richiesti",
            }).then(async () => {
                this.company.nexiRatesEnabled = 0;
                await this.companyService.enableDisablePaymentMethod({nexiRatesEnabled: this.company.nexiRatesEnabled}, this.companyId);
                window.location.reload()
                return;
            })
        } else {
            this.company.nexiRatesEnabled = this.company.nexiRatesEnabled ? 0 : 1;
            await this.companyService.enableDisablePaymentMethod({nexiRatesEnabled: this.company.nexiRatesEnabled}, this.companyId);
        }
    }

    async enableDisablePosNexi() {
        this.company.posNexiEnabled = this.company.posNexiEnabled ? 0 : 1;
        await this.companyService.enableDisablePaymentMethod({posNexiEnabled: this.company.posNexiEnabled}, this.companyId);
    }

    async enableDisableLocalPayment() {
        this.company.localPaymentEnabled = this.company.localPaymentEnabled ? 0 : 1;
        await this.companyService.enableDisablePaymentMethod({localPaymentEnabled: this.company.localPaymentEnabled}, this.companyId);
    }


    /** Ruoli consentiti per inviti collegati a una società (whitelist su id dall’API). */
    private isCompanyInviteRoleId(id?: string): boolean {
        const key = (id ?? '').trim().toLowerCase();
        return ['companymanager', 'accompagnatore', 'mister', 'staff'].includes(key);
    }

    /** Ordine suggerito per schede ruolo (più rilevanti per chi gestisce la società). */
    private sortInviteRoles(groups: UserGroup[]): UserGroup[] {
        const rank = (gid: string) => {
            const k = gid.toLowerCase();
            const order = ['companymanager', 'mister', 'accompagnatore', 'staff'];
            const i = order.indexOf(k);
            return i === -1 ? 999 : i;
        };
        return [...groups].sort((a, b) => rank(a.id ?? '') - rank(b.id ?? ''));
    }

    /** Opzioni statiche minim se l’API non risponde. */
    private defaultCompanyInviteRoles(): UserGroup[] {
        return [
            new UserGroup({ id: 'companyManager', name: 'Amministratore società' }),
            new UserGroup({ id: 'mister', name: 'Staff / allenatore' }),
            new UserGroup({ id: 'user', name: 'Utente piattaforma' }),
            new UserGroup({ id: 'admin', name: 'Amministratore piattaforma' }),
        ];
    }

    async loadCompanyInviteRoles() {
        try {
            const raw = await this.userService.typeOfAccount();
            console.log('raw', raw)
            const filtered = (raw ?? []).filter((g) => this.isCompanyInviteRoleId(g.id));
            this.companyInviteRoleOptions =
                filtered.length > 0 ? this.sortInviteRoles(filtered) : this.defaultCompanyInviteRoles();
        } catch {
            this.companyInviteRoleOptions = this.defaultCompanyInviteRoles();
        }
        if (!this.selectedInviteRoleId) {
            this.selectedInviteRoleId = this.pickDefaultInviteRoleId();
        }
    }

    pickDefaultInviteRoleId(): string {
        const preferred =
            this.companyInviteRoleOptions.find((g) => g.id?.toLowerCase() === 'companymanager') ??
            this.companyInviteRoleOptions[0];
        return preferred?.id ?? 'companyManager';
    }

    resetInviteUserForm() {
        this.newUser = new User();
        this.newUser.linkedCompanyId = this.companyId ?? '';
        this.selectedInviteRoleId = this.pickDefaultInviteRoleId();
        this.inviteMisterCategoriesSelected = [];
        this.showInvitePassword = false;
        this.showInviteConfirmPassword = false;
        queueMicrotask(() => {
            if (this.confirmPassword?.nativeElement) {
                this.confirmPassword.nativeElement.value = '';
            }
        });
    }

    /** Confronto ruolo invito (case-insensitive, es. `mister` / `Mister`). */
    isInviteRole(roleId: string): boolean {
        const a = (this.selectedInviteRoleId ?? '').trim().toLowerCase();
        const b = (roleId ?? '').trim().toLowerCase();
        return a.length > 0 && a === b;
    }

    selectInviteRole(roleId: string) {
        this.selectedInviteRoleId = roleId;
        if (!this.isInviteRole('mister')) {
            this.inviteMisterCategoriesSelected = [];
        } else if (this.inviteMisterCategoryOptions.length === 0 && !this.inviteMisterCategoriesLoading) {
            void this.loadInviteMisterCategories();
        }
    }

    async loadInviteMisterCategories() {
        if (!this.companyId) {
            this.inviteMisterCategoryOptions = [];
            return;
        }
        this.inviteMisterCategoriesLoading = true;
        try {
            const seasonsRes = await this.seasonService.getSeasons(this.companyId, {isCurrent: true});
            const currentSeasonId = seasonsRes?.data?.[0]?.id as string | undefined;
            const all = await this.categoryService.getCategories(
                this.companyId,
                false,
                currentSeasonId ? {seasonId: currentSeasonId} : undefined
            );
            const leaves = all
                .filter((c: Category) => !!c.id && c.parentId != null)
                .map((c: Category) => ({
                    id: c.id as string,
                    name: c.parent ? `${c.parent.name} - ${c.name}` : c.name,
                }));
            const roots = all
                .filter((c: Category) => !!c.id && !c.parentId)
                .map((c: Category) => ({id: c.id as string, name: c.name}));
            this.inviteMisterCategoryOptions = (leaves.length > 0 ? leaves : roots).sort((x, y) =>
                x.name.localeCompare(y.name, 'it')
            );
            const validIds = new Set(this.inviteMisterCategoryOptions.map((c) => c.id));
            this.inviteMisterCategoriesSelected = this.inviteMisterCategoriesSelected.filter((c) =>
                validIds.has(c.id)
            );
            this.editMisterCategoriesSelected = this.editMisterCategoriesSelected.filter((c) =>
                validIds.has(c.id)
            );
        } catch {
            this.inviteMisterCategoryOptions = [];
        } finally {
            this.inviteMisterCategoriesLoading = false;
        }
    }

    /** Etichetta ruolo leggibile per riga tabella / messaggi (anche prima del caricamento API). */
    getUserRoleDisplayName = (userGroupId?: string): string => {
        const id = userGroupId?.trim();
        if (!id) {
            return 'Ruolo non indicato';
        }
        const fromApi =
            this.companyInviteRoleOptions.find((g) => g.id?.toLowerCase() === id.toLowerCase())?.name ??
            this.defaultCompanyInviteRoles().find((g) => g.id?.toLowerCase() === id.toLowerCase())?.name;
        if (fromApi) {
            return fromApi;
        }
        const fallback: Record<string, string> = {
            companymanager: 'Amministratore società',
            companyManager: 'Amministratore società',
            admin: 'Amministratore piattaforma',
            mister: 'Staff / allenatore',
            user: 'Utente piattaforma',
        };
        return fallback[id] ?? fallback[id.toLowerCase()] ?? id;
    }

    // * Users
    isUserMister(user?: User | null): boolean {
        return (user?.userGroupId ?? '').trim().toLowerCase() === 'mister';
    }

    private extractUserCategoryIds(raw: unknown): string[] {
        const fromUser = User.normalizeCategoryIds(raw as User);
        if (fromUser?.length) {
            return fromUser;
        }
        const r = raw as {
            userCategories?: unknown;
            UserCategories?: unknown;
        };
        return User.normalizeCategoryIds({
            categoryIds: r?.userCategories ?? r?.UserCategories,
        }) ?? [];
    }

    private categoryLabelFromRaw(item: unknown): string | undefined {
        if (!item || typeof item !== 'object') {
            return undefined;
        }
        const c = item as { name?: string; label?: string; category?: { name?: string; parent?: { name?: string } } };
        if (c.name) {
            return c.name;
        }
        if (c.label) {
            return c.label;
        }
        if (c.category?.parent?.name && c.category?.name) {
            return `${c.category.parent.name} - ${c.category.name}`;
        }
        return c.category?.name;
    }

    private rawCategoryItems(raw: unknown): unknown[] {
        const r = raw as { categories?: unknown; userCategories?: unknown; UserCategories?: unknown };
        if (Array.isArray(r?.categories)) {
            return r.categories;
        }
        if (Array.isArray(r?.userCategories)) {
            return r.userCategories;
        }
        if (Array.isArray(r?.UserCategories)) {
            return r.UserCategories;
        }
        return [];
    }

    private async resolveEditMisterCategorySelections(
        raw: unknown,
        categoryIds: string[],
    ): Promise<{ id: string; name: string }[]> {
        const optionById = new Map(this.inviteMisterCategoryOptions.map((c) => [c.id, c]));
        const namesById = new Map<string, string>();
        for (const item of this.rawCategoryItems(raw)) {
            if (!item || typeof item !== 'object') {
                continue;
            }
            const obj = item as { id?: string; categoryId?: string; category?: { id?: string; name?: string } };
            const id = String(obj.id ?? obj.categoryId ?? obj.category?.id ?? '').trim();
            const label = this.categoryLabelFromRaw(item) ?? obj.category?.name;
            if (id && label) {
                namesById.set(id, label);
            }
        }

        const selected: { id: string; name: string }[] = [];
        for (const id of categoryIds) {
            if (optionById.has(id)) {
                selected.push(optionById.get(id)!);
                continue;
            }
            if (namesById.has(id)) {
                selected.push({ id, name: namesById.get(id)! });
                continue;
            }
            try {
                const cat = await this.categoryService.getCategoryById(id);
                if (cat?.id) {
                    const name = cat.parent ? `${cat.parent.name} - ${cat.name}` : cat.name;
                    selected.push({ id: cat.id as string, name });
                    continue;
                }
            } catch {
                /* ignore */
            }
            selected.push({ id, name: namesById.get(id) ?? id });
        }
        return selected;
    }

    /** Arrow: required when passing to ui-table `addButtonCallback` (otherwise `this` is lost inside TableComponent.addElement). */
    openUserModal = async (user?: User) => {
        if (user) {
            this.newPassword = '';
            this.resubmitPassword = '';
            this.editMisterCategoriesSelected = [];
            this.editMisterCategoriesReady = false;

            let userData: User = user;
            if (this.isUserMister(user) && user.id) {
                const [full] = await Promise.all([
                    this.userService.getUserById(user.id),
                    this.loadInviteMisterCategories(),
                ]);
                const raw = { ...user, ...(full as object) };
                userData = new User(raw as User);
                const categoryIds = this.extractUserCategoryIds(raw);
                this.editMisterCategoriesSelected = await this.resolveEditMisterCategorySelections(
                    raw,
                    categoryIds,
                );
                this.editMisterCategoriesReady = true;
            }

            this.modal.setModalData(userData, 'editUserPassword');
            this.modal.getModal('editUserPassword').open();
        } else {
            this.resetInviteUserForm();
            this.modal.getModal('addUserModal').open();
        }
    };

    closeAddUserModal() {
        this.modal.getModal('addUserModal').close();
    }

    closeEditUserModal() {
        this.modal.getModal('editUserPassword').close();
    }

    onCloseEditUserModal() {
        this.clearModalData('editUserPassword');
        this.cleanEditUserPasswordModal();
    }

    cleanEditUserPasswordModal() {
        this.newPassword = '';
        this.resubmitPassword = '';
        this.editMisterCategoriesSelected = [];
        this.editMisterCategoriesReady = false;
    }

    isEditTeamUserValid(): boolean {
        const user = this.modal.getModal('editUserPassword')?.getData() as User | undefined;
        if (!user?.id) {
            return false;
        }
        const pwdA = (this.newPassword ?? '').trim();
        const pwdB = (this.resubmitPassword ?? '').trim();
        const pwdOk = (!pwdA && !pwdB) || this.doPasswordsMatch(pwdA, pwdB);
        if (this.isUserMister(user)) {
            return this.editMisterCategoriesSelected.length > 0 && pwdOk;
        }
        return this.doPasswordsMatch(this.newPassword, this.resubmitPassword);
    }

    async saveEditTeamUser() {
        const user = this.modal.getModal('editUserPassword')?.getData() as User | undefined;
        if (!user?.id) {
            return;
        }

        let categoriesOk = true;
        let passwordOk = true;
        const pwd = (this.newPassword ?? '').trim();

        if (this.isUserMister(user)) {
            categoriesOk = await this.userService.updateUser({
                id: user.id,
                categoryIds: this.editMisterCategoriesSelected.map((c) => c.id),
            } as User);
        }

        if (pwd) {
            passwordOk = await this.userService.updatePassword(pwd, user.id);
        }

        if (categoriesOk && passwordOk) {
            await Swal.fire({
                icon: 'success',
                title: this.isUserMister(user) && pwd ? 'Accesso aggiornato' : pwd ? 'Password aggiornata' : 'Categorie aggiornate',
            });
            await this.loadLinkedCompanyTeamUsers();
            this.modal.getModal('editUserPassword').close();
        } else {
            await Swal.fire({
                icon: 'error',
                title: 'Non è stato possibile salvare le modifiche',
                text: 'Controlla i dati e riprova, oppure contatta l’assistenza.',
            });
        }
    }

    async createUser() {

        const userGroupId = this.selectedInviteRoleId?.trim() || this.pickDefaultInviteRoleId();

        this.newUser = {
            ...this.newUser,
            userGroupId,
            linkedCompanyId: this.companyId ?? '',
        };
        if (this.isInviteRole('mister')) {
            this.newUser.categoryIds = this.inviteMisterCategoriesSelected.map((c) => c.id);
        } else {
            delete this.newUser.categoryIds;
        }

        const response = await this.userService.createNewUser(this.newUser);
        if (response.success) {
            await Swal.fire({
                icon: 'success',
                title: 'Persona aggiunta correttamente',
            });
            await this.loadLinkedCompanyTeamUsers();
            this.closeAddUserModal();
        } else {
            if (response.code === 'USER_EMAIL_ALREADY_USE') {
                await Swal.fire({
                    icon: 'error',
                    title: 'Non è stato possibile creare l’utente',
                    text: 'Utente con questa email già esistente, controlla i dati e riprova, oppure contatta l’assistenza.',
                });
            } else {
                await Swal.fire({
                    icon: 'error',
                    title: 'Non è stato possibile creare l’utente',
                    text: 'Controlla i dati e riprova, oppure contatta l’assistenza.',
                });
            }


        }
    }

    doPasswordsMatch(firstPassword: string | undefined | null, secondPassword: string | undefined | null) {
        const a = (firstPassword ?? '').trim();
        const b = (secondPassword ?? '').trim();
        return a === b && a.length > 0 && b.length > 0;
    }

    isUserNotValid() {
        const confirmVal = this.confirmPassword?.nativeElement?.value;
        const pwdOk = this.doPasswordsMatch(this.newUser.password, confirmVal);
        const misterCategoriesOk = !this.isInviteRole('mister') || this.inviteMisterCategoriesSelected.length > 0;
        return (
            !this.selectedInviteRoleId ||
            !this.newUser.firstName ||
            !this.newUser.lastName ||
            !this.newUser.email ||
            !pwdOk ||
            !misterCategoriesOk
        );
    }



    // * Documents
    async uploadDocument(event: any) {
        event.preventDefault();
        this.spinner.show();
        this.athleteDocument.documentTypes = (this.selectedDocumentTypes && this.selectedDocumentTypes.length)
            ? this.selectedDocumentTypes.map((t: any) => t.id).join(',')
            : '';
        console.log("athleteDocument to upload", this.athleteDocument.documentTypes)
        let response = await this.companyDocumentService.uploadCompanyDocumentModel(this.athleteDocument, this.companyId);

        if (response.success) {
            // Clear form
            this.athleteDocument = {
                name: '',
                description: '',
                documentTypes: '',
                isMandatory: 1,
                hasExpirationDate: 1,
                primaryDocument: 0,
                modelUrl: ''
            };
            this.selectedDocumentTypes = [];

            const fileInput = document.getElementById('model-document') as HTMLInputElement;
            /*if (fileInput) {
                fileInput.value = '';
            }*/

            Swal.fire({
                icon: 'success',
                title: 'Documento inserito con successo'
            })
            await this.primaryDocumentCheck()
        } else if (!response.success && response.code == 'PRIMARY_DOCUMENT_ALREADY_EXISTS') {
            this.hideSpinner()
            Swal.fire({
                icon: 'error',
                title: 'È possibile inserire solo un documento primario'
            })
        } else {
            Swal.fire({
                icon: 'error',
                title: 'Errore nel caricamento del documento'
            });
        }
        this.spinner.hide();

    }


    openEditDocumentModal(documentToEdit: CompanyDocument) {
        const rowClone = JSON.parse(JSON.stringify(documentToEdit));
        console.log("rowClone", rowClone)
        let rowDocumentTypes: any[] = [];
        if (Array.isArray(rowClone.documentTypes)) {
            rowDocumentTypes = rowClone.documentTypes;
        } else if (typeof rowClone.documentTypes === 'string') {
            try {
                const parsedDocumentTypes = JSON.parse(rowClone.documentTypes);
                rowDocumentTypes = Array.isArray(parsedDocumentTypes) ? parsedDocumentTypes : [rowClone.documentTypes];
            } catch {
                rowDocumentTypes = rowClone.documentTypes
                    .split(',')
                    .map((documentType: string) => documentType.trim())
                    .filter(Boolean);
            }
        }

        this.editDocumentSelectedTypes = rowDocumentTypes
            .map((documentType: any) => {
                if (documentType && typeof documentType === 'object' && documentType.id) {
                    return this.documentTypes.find(type => type.id === documentType.id) ?? null;
                }
                const documentTypeId = typeof documentType === 'string' ? documentType : '';
                return this.documentTypes.find(type => type.id === documentTypeId) ?? null;
            })
            .filter((type: { id: string, name: string } | null): type is { id: string, name: string } => !!type);

        this.modal.getModal('editDocumentModal').setData(rowClone);
        this.modal.getModal('editDocumentModal').open();

    }

    async chooseDocumentModel(event: any) {
        this.modelDocument = event.target.files[0];

        if (!this.modelDocument) return;

        const formData = new FormData();
        formData.append('file', this.modelDocument);

        this.showSpinner()

        const response = await this.companyDocumentService.uploadModelDocument(formData);
        console.log(response)
        this.modelDocumentUrl = response.data;
        this.athleteDocument['modelUrl'] = this.modelDocumentUrl;
        this.showModelDocumentPreview = true
        console.log(this.showModelDocumentPreview)
        console.log(response.code)
        if (response.success) {
            this.hideSpinner()
            Swal.fire({
                icon: 'success',
                title: 'Documento caricato con successo'
            })
            this.adminDocumentsTable?.reloadPage();
        } else {
            this.hideSpinner()
            Swal.fire({
                icon: 'error',
                title: 'Errore nel caricamento del documento'
            })
        }
    }

    async updateDocument(documentUpdated: CompanyDocument) {
        documentUpdated.modelUrl = this.modelDocumentUrl;
        documentUpdated.documentTypes = (this.editDocumentSelectedTypes && this.editDocumentSelectedTypes.length)
            ? this.editDocumentSelectedTypes.map(t => t.id).join(',')
            : '';
        console.log("documentUpdated.documentTypes", documentUpdated.documentTypes);
        let response = await this.companyDocumentService.updateCompanyDocumentModel(documentUpdated);

        if (response.success) {
            Swal.fire({
                icon: 'success',
                title: "Documento aggiornato con successo"
            })
            await this.primaryDocumentCheck();
            this.modal.getModal('editDocumentModal').close();
        } else if (!response.success && response.code == 'PRIMARY_DOCUMENT_ALREADY_EXISTS') {
            Swal.fire({
                icon: 'error',
                title: 'È possibile inserire solo un documento primario'
            })
        } else {
            Swal.fire({
                icon: 'error',
                title: "Errore durante l'aggiornamento del documento"
            });
        }
    }

    removeDocumentModel(documentToDelete: CompanyDocument) {
        Swal.fire({
            icon: 'warning',
            title: "Sei sicuro di voler eliminare il documento selezionato?",
            showCancelButton: true,
            confirmButtonText: "Si, elimina il documento selezionato",
            cancelButtonText: "No, annulla l'operazione"
        })
            .then(async (response: SweetAlertResult) => {
                if (response.isConfirmed) {
                    this.athleteDocumentsTable?.reloadPage()
                    this.primaryDocumentCheck();
                    if ((await this.companyDocumentService.deleteDocument(documentToDelete)).success) {
                        Swal.fire({
                            icon: 'success',
                            title: 'Documento eliminato con successo'
                        })
                            .then(_ => this.athleteDocumentsTable?.reloadPage());
                        this.primaryDocumentCheck();
                    } else {
                        Swal.fire({
                            icon: 'error',
                            title: "Errore nella cancellazione del documento, riprova"
                        })
                    }
                }
                if (response.isDismissed) {
                    // niente
                }
            });
    }

    reuploadFile() {

    }

    chooseDocument(event: any) {
        this.adminDocumentFile = event.target.files[0];
    }


    async uploadAdminDocument() {
        if (!this.adminDocumentFile) return;

        const formData = new FormData();
        formData.append('file', this.adminDocumentFile)

        this.showSpinner()

        if ((await this.adminDocumentService.uploadAdminDocument(formData, this.adminDocumentType, this.companyId)).success) {
            this.hideSpinner()
            Swal.fire({
                icon: 'success',
                title: 'Documento caricato con successo'
            })
            this.adminDocumentsTable?.reloadPage();
        } else {
            this.hideSpinner()
            Swal.fire({
                icon: 'error',
                title: 'Errore nel caricamento del documento'
            })
        }
    }

    async approveDocument(documentId: string) {
        let response = await this.adminDocumentService.approveDocument(documentId, this.companyId);

        if (response.success) {
            Swal.fire({
                icon: "success",
                title: "Documento approvato"
            });
            this.adminDocumentsTable?.reloadPage()
        } else {
            Swal.fire({
                icon: "error",
                title: "Errore durante l'approvazione del documento"
            });
        }
    }

    async rejectDocument(documentId: string) {
        let response = await this.adminDocumentService.rejectDocument(documentId, this.companyId);

        if (response.success) {
            Swal.fire({
                icon: "success",
                title: "Documento rifiutato"
            });
            this.adminDocumentsTable?.reloadPage()
        } else {
            Swal.fire({
                icon: "error",
                title: "Errore durante il rifiuto del documento"
            });
        }
    }

    async approveCompany(companyId: string) {
        if (this.approvingCompany) {
            return;
        }

        this.approvingCompany = true;
        try {
            const response = await this.companyService.approveCompany(companyId);

            if (response?.success) {
                Swal.fire({
                    icon: 'success',
                    title: 'Società accettata!'
                });
            } else {
                Swal.fire({
                    icon: 'error',
                    title: "Errore durante l'operazione"
                });
            }

            this.router.navigate(['/admins/dashboard']);
        } finally {
            this.approvingCompany = false;
        }
    }

    async refuseCompany(companyId: string) {
        const response = await this.companyService.refuseCompany(companyId);

        if (response.success) {
            Swal.fire({
                icon: 'success',
                title: 'Società rifiutata!'
            });
        } else {
            Swal.fire({
                icon: 'error',
                title: "Errore durante l'operazione"
            });
        }
        this.router.navigate(['/admins/dashboard']);

    }

    async chooseRulesDocument(event: any) {
        this.companyRulesFile = event.target.files[0];

        if (!this.companyRulesFile) return;

        const formData = new FormData();
        formData.append('file', this.companyRulesFile)

        this.showSpinner()

        const uploadRules = await this.companyService.uploadCompany(formData);


        console.log('upload: ', uploadRules)

        if (uploadRules.success) {
            this.responseCompanyRules = uploadRules.data
            this.company['rulesUrl'] = uploadRules.data;
            let updateResponse = await this.companyService.updateCompany(this.company.id, this.company);
            if (updateResponse.success) {
                this.hideSpinner()
                Swal.fire({
                    icon: 'success',
                    title: 'Documento caricato con successo'
                })
            } else {
                this.hideSpinner()
                Swal.fire({
                    icon: 'error',
                    title: 'Errore nel caricamento del documento'
                })
            }

        } else {
            this.hideSpinner()
            Swal.fire({
                icon: 'error',
                title: 'Errore nel caricamento del documento'
            })
        }
    }

    async chooseSignatureFile(event: any) {
        this.companySignatureFile = event.target.files[0];

        if (!this.companySignatureFile) return;

        const formData = new FormData();
        formData.append('file', this.companySignatureFile)

        this.showSpinner()

        const uploadSiganture = await this.companyService.uploadCompany(formData);

        if (uploadSiganture.success) {
            this.responseCompanyRules = uploadSiganture.data
            this.company['signature'] = uploadSiganture.data;
            let updateResponse = await this.companyService.updateCompany(this.company.id, this.company);
            if (updateResponse.success) {
                this.hideSpinner()
                Swal.fire({
                    icon: 'success',
                    title: 'Firma caricata con successo'
                })
            } else {
                this.hideSpinner()
                Swal.fire({
                    icon: 'error',
                    title: 'Errore nel caricamento della firma'
                })
            }

        } else {
            this.hideSpinner()
            Swal.fire({
                icon: 'error',
                title: 'Errore nel caricamento della firma'
            })
        }
    }

    updateCitiesLegal() {
        this.cities = this.citiesForProvince(this.company.province);
    }

    updateLegalResidenceCities() {
        this.legalCities = this.citiesForProvince(this.company.legalProvince);
    }

    private citiesForProvince(provinceCode?: string): string[] {
        if (!provinceCode || !this.data?.length) {
            return [];
        }
        let comuni: any[] = [];
        this.data.forEach((region: any) => {
            const match = region.province.find((province: any) => province.code === provinceCode);
            if (match) {
                comuni = match.comuni;
            }
        });
        return comuni.map((city: any) => city.nome).sort();
    }


    requiredFields() {
        return !!this.company.domain
    }


    disableNexiRates() {
        return (
            this.company.nexiRatesCommissionPercent !== 0 &&
            this.company.nexiRatesShopId !== '' &&
            this.company.nexiRatesApiKey !== ''
        )
    }

    async primaryDocumentCheck() {
        await this.loadData()
        this.primaryDocumentExists = false;
        if (this.athleteDocumentsTable && this.athleteDocumentsTable.rows) {
            for (const document of this.athleteDocumentsTable!.rows) {
                if (document.primaryDocument === 1) {
                    this.primaryDocumentExists = true;
                    console.log(this.primaryDocumentExists);
                    break;
                }
            }
        }

    }

    async loginAsUser(user: User) {
        if (!user?.id || !user.email) {
            this.showErrorMessage('Impossibile accedere: utente senza email');
            return;
        }

        try {
            const response: any = await this.userService.loginAs(user.email, user.id);
            if (!response?.success) {
                let message = 'Errore generico';
                if (response?.code === 'USER_NOT_FOUND') {
                    message = 'Utente non trovato';
                }
                if (response?.code === 'INCORRECT_PASSWORD') {
                    message = 'Password errata';
                }
                await Swal.fire({ icon: 'error', title: message });
                return;
            }
            setTimeout(() => {
                window.location.reload();
            }, 300);
        } catch (error) {
            console.error('Login as user error: ', error);
            this.showErrorMessage('Errore durante l\'accesso come utente');
        }
    }

    async deleteUser(id: string) {
        this.showSpinner()
        try {
            const response: any = await this.userService.deleteUser(id)
            if (response.success) {
                this.showSuccessMessage('Utente eliminato con successo');
            }
            await this.loadLinkedCompanyTeamUsers();
            this.hideSpinner()
        } catch (error) {
            this.hideSpinner()
            this.showErrorMessage('Errore durante l\'eliminazione dell\'utente');
        }
    }

    getDocumentTypesLabels(ids: string[] | string | null | undefined): string[] {
        if (!ids) return [];
        let idArray: string[] = [];
        if (Array.isArray(ids)) idArray = ids;
        else if (typeof ids === 'string') {
            try {
                const parsed = JSON.parse(ids);
                if (Array.isArray(parsed)) {
                    idArray = parsed;
                } else {
                    idArray = [ids];
                }
            } catch {
                idArray = ids.split(',').map(s => s.trim());
            }
        }

        if (!idArray.length || !this.documentTypes?.length) return [];

        const typeMap = new Map(this.documentTypes.map(t => [t.id.toLowerCase().trim(), t.name]));
        const labels = idArray.map(id => typeMap.get(id.toLowerCase().trim())).filter((name): name is string => !!name);

        return labels;
    }

    getDocumentTypesLabel(ids: string[] | string | null | undefined): string {
        const labels = this.getDocumentTypesLabels(ids);
        return labels.length ? labels.join(', ') : 'Nessuna tipologia';
    }

}
